module.exports = __webpack_public_path__ + "img/628.Cold_drinks_cups.9ff83d6e.svg";